import { ChangeDetectionStrategy, Component, computed, ElementRef, input, model, signal, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FikoYTKokBilesenComponent } from '../../../../../kok-bilesen/kok-bilesen.component';
import { IDosyaKutusuAyarlar, IDosyaKutusuOge } from '../../../../interfaces/IParametre/IParametre';
import { FikoYTId } from '../../../../helpers/FikoYTId';

@Component({
  selector: 'dosya-kutusu',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (!sadeceOkunur()) {
    <div class="dk-wrap">
      <div class="dk-toolbar">
        <button class="dk-btn dk-btn--klasor" (click)="yeniKlasor()">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z"/></svg>
          Klasör
        </button>
        <button class="dk-btn dk-btn--dosya" (click)="dosyaSec()">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
          Dosya Ekle
        </button>
        <input type="file" #dosyaInput multiple hidden (change)="dosyalarEklendi($event)" />
      </div>

      @if (aktifKlasorId()) {
        <div class="dk-breadcrumb">
          <span class="dk-bc-oge" (click)="aktifKlasorId.set(null)">Kök</span>
          @for (bc of breadcrumb(); track bc._id) {
            <span class="dk-bc-ok">›</span>
            <span class="dk-bc-oge" (click)="aktifKlasorId.set(bc._id)">{{ bc.ismi }}</span>
          }
        </div>
      }

      <div class="dk-drop"
           (dragover)="$event.preventDefault(); dragUzerinde.set(true)"
           (dragleave)="dragUzerinde.set(false)"
           (drop)="dosyaBirak($event)"
           [class.dk-drop--aktif]="dragUzerinde()">
        @if (gorunenOgeler().length === 0) {
          <div class="dk-bos">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/>
              <polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/>
            </svg>
            <span>Dosya sürükleyin veya yukarıdan ekleyin</span>
          </div>
        }

        @for (oge of gorunenOgeler(); track oge._id) {
          <div class="dk-oge" [class.dk-oge--klasor]="oge.tur === 'klasor'"
               [class.dk-oge--genisletildi]="genisletilen().has(oge._id)"
               draggable="true" (dragstart)="suruklenenId = oge._id"
               (dragover)="oge.tur === 'klasor' && $event.preventDefault()"
               (drop)="klasoreTasi(oge._id, $event)">
            <div class="dk-oge-satir">
              <span class="dk-ikon" (click)="oge.tur === 'klasor' && aktifKlasorId.set(oge._id)">
                {{ oge.tur === 'klasor' ? '\uD83D\uDCC1' : dosyaIkonu(oge.tipi) }}
              </span>
              @if (duzenlenenId() === oge._id) {
                <input class="dk-isim-input" [value]="oge.ismi"
                       (blur)="isimKaydet(oge._id, $any($event.target).value)"
                       (keydown.enter)="$any($event.target).blur()"
                       (keydown.escape)="duzenlenenId.set(null)"
                       #isimInput />
              } @else {
                <span class="dk-isim"
                      (click)="isimTiklandi(oge)"
                      (dblclick)="isimCiftTiklandi(oge); $event.stopPropagation()">
                  {{ oge.ismi }}
                </span>
              }
              @if (oge.tur === 'dosya' && oge.boyut) {
                <span class="dk-boyut">{{ formatBoyut(oge.boyut) }}</span>
              }
              @if (oge.tur === 'klasor') {
                <span class="dk-boyut">{{ cocukSayisi(oge._id) }} öge</span>
              }
              <button class="dk-btn-mini" (click)="toggleGenislet(oge._id)" title="Açıklama">
                \uD83D\uDCAC
              </button>
              <button class="dk-btn-mini dk-btn-mini--sil" (click)="ogeSil(oge._id)">\u2715</button>
            </div>
            @if (genisletilen().has(oge._id)) {
              <div class="dk-detay">
                <input class="dk-aciklama-input" placeholder="Açıklama ekle..."
                       [value]="oge.aciklama || ''"
                       (input)="ogeGuncelle(oge._id, 'aciklama', $any($event.target).value)" />
              </div>
            }
          </div>
        }
      </div>

      <div class="dk-footer">
        <span>{{ toplamDosya() }} dosya, {{ toplamKlasor() }} klasör</span>
        <span>{{ formatBoyut(toplamBoyut()) }}</span>
      </div>
    </div>
    } @else {
    <div class="dk-wrap dk-wrap--oku">
      @if (aktifKlasorId()) {
        <div class="dk-breadcrumb">
          <span class="dk-bc-oge" (click)="aktifKlasorId.set(null)">Kök</span>
          @for (bc of breadcrumb(); track bc._id) {
            <span class="dk-bc-ok">›</span>
            <span class="dk-bc-oge" (click)="aktifKlasorId.set(bc._id)">{{ bc.ismi }}</span>
          }
        </div>
      }
      @for (oge of gorunenOgeler(); track oge._id) {
        <div class="dk-oge dk-oge--oku"
             (click)="oge.tur === 'klasor' ? aktifKlasorId.set(oge._id) : null">
          <span class="dk-ikon">{{ oge.tur === 'klasor' ? '\uD83D\uDCC1' : dosyaIkonu(oge.tipi) }}</span>
          <span class="dk-isim">{{ oge.ismi }}</span>
          @if (oge.tur === 'dosya' && oge.boyut) {
            <span class="dk-boyut">{{ formatBoyut(oge.boyut) }}</span>
          }
          @if (oge.tur === 'klasor') {
            <span class="dk-boyut">{{ cocukSayisi(oge._id) }} öge</span>
          }
        </div>
        @if (oge.aciklama) {
          <div class="dk-aciklama-oku">{{ oge.aciklama }}</div>
        }
      }
      <div class="dk-footer">
        <span>{{ toplamDosya() }} dosya, {{ toplamKlasor() }} klasör</span>
        <span>{{ formatBoyut(toplamBoyut()) }}</span>
      </div>
    </div>
    }
  `,
  styles: [`
    .dk-wrap { border: 1px solid var(--py-kenarlik); border-radius: 8px; overflow: hidden; }
    .dk-toolbar { display: flex; gap: 4px; padding: 6px 8px; background: var(--py-arkaplan-soluk); border-bottom: 1px solid var(--py-kenarlik); }
    .dk-btn { font-size: 11px; padding: 3px 8px; border-radius: 4px; border: 1px solid var(--py-kenarlik); cursor: pointer; transition: all .2s; background: transparent; display: inline-flex; align-items: center; gap: 4px; color: var(--py-metin); }
    .dk-btn:hover { background: var(--py-arkaplan-hover); }
    .dk-btn--klasor { color: #f59e0b; }
    .dk-btn--dosya { color: #3b82f6; }
    .dk-breadcrumb { display: flex; align-items: center; gap: 4px; padding: 4px 8px; font-size: 11px; color: var(--py-metin-ucuncul); }
    .dk-bc-oge { cursor: pointer; &:hover { color: var(--py-link); } }
    .dk-bc-ok { font-size: 10px; opacity: .4; }
    .dk-drop { min-height: 40px; position: relative; }
    .dk-drop--aktif { background: rgba(59,130,246,.05); }
    .dk-bos { text-align: center; padding: 16px; color: var(--py-metin-ucuncul); font-size: 12px; display: flex; flex-direction: column; align-items: center; gap: 6px; }
    .dk-oge { border-bottom: 1px solid var(--py-kenarlik); transition: background .2s; }
    .dk-oge:hover { background: var(--py-arkaplan-hover); }
    .dk-oge:last-child { border-bottom: none; }
    .dk-oge--klasor .dk-isim { cursor: pointer; font-weight: 600; }
    .dk-oge-satir { display: flex; align-items: center; gap: 6px; padding: 4px 8px; min-height: 32px; }
    .dk-ikon { font-size: 16px; flex-shrink: 0; width: 20px; text-align: center; }
    .dk-isim { flex: 1; font-size: 12px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; cursor: default; }
    .dk-isim-input { flex: 1; font-size: 12px; border: 1px solid var(--py-kenarlik-aktif, #1890ff); border-radius: 4px; padding: 2px 6px; background: var(--py-input-arka, #fff); color: var(--py-metin, #333); outline: none; min-width: 0; }
    .dk-boyut { font-size: 10px; color: var(--py-metin-ucuncul); flex-shrink: 0; }
    .dk-btn-mini { width: 20px; height: 20px; border: none; background: none; cursor: pointer; border-radius: 4px; font-size: 12px; opacity: .4; transition: all .2s; display: flex; align-items: center; justify-content: center; }
    .dk-btn-mini:hover { opacity: 1; background: var(--py-arkaplan-hover); }
    .dk-btn-mini--sil:hover { color: #ef4444; }
    .dk-detay { padding: 4px 8px 8px 34px; }
    .dk-aciklama-input { width: 100%; border: 1px solid var(--py-kenarlik); border-radius: 4px; padding: 4px 8px; font-size: 11px; background: transparent; color: var(--py-metin); }
    .dk-aciklama-oku { padding: 0 8px 4px 34px; font-size: 10px; color: var(--py-metin-ucuncul); }
    .dk-footer { display: flex; justify-content: space-between; padding: 4px 8px; font-size: 10px; color: var(--py-metin-ucuncul); border-top: 1px solid var(--py-kenarlik); }
    .dk-wrap--oku .dk-oge--oku { cursor: default; }
    .dk-wrap--oku .dk-oge--oku.dk-oge--klasor { cursor: pointer; }
  `]
})
export class DosyaKutusuComponent extends FikoYTKokBilesenComponent {
  @ViewChild('dosyaInput') dosyaInput!: ElementRef<HTMLInputElement>;

  deger = model<{ dosyalar: IDosyaKutusuOge[] }>();
  ayarlar = input<IDosyaKutusuAyarlar>();
  sadeceOkunur = input(false);

  aktifKlasorId = signal<string | null>(null);
  duzenlenenId = signal<string | null>(null);
  dragUzerinde = signal(false);
  genisletilen = signal<Set<string>>(new Set());
  suruklenenId: string | null = null;

  tumDosyalar = computed(() => this.deger()?.dosyalar || []);

  gorunenOgeler = computed(() => {
    const kid = this.aktifKlasorId();
    return this.tumDosyalar().filter(d => (d.ustId || null) === kid);
  });

  breadcrumb = computed(() => {
    const kid = this.aktifKlasorId();
    if (!kid) return [];
    const yol: IDosyaKutusuOge[] = [];
    let mevcut = this.tumDosyalar().find(d => d._id === kid);
    while (mevcut) {
      yol.unshift(mevcut);
      mevcut = mevcut.ustId ? this.tumDosyalar().find(d => d._id === mevcut!.ustId) : undefined;
    }
    return yol;
  });

  toplamDosya = computed(() => this.tumDosyalar().filter(d => d.tur === 'dosya').length);
  toplamKlasor = computed(() => this.tumDosyalar().filter(d => d.tur === 'klasor').length);
  toplamBoyut = computed(() => this.tumDosyalar().filter(d => d.tur === 'dosya').reduce((t, d) => t + (d.boyut || 0), 0));

  constructor() { super(); }

  cocukSayisi(klasorId: string): number {
    return this.tumDosyalar().filter(d => d.ustId === klasorId).length;
  }

  yeniKlasor() {
    const dosyalar = [...(this.deger()?.dosyalar || [])];
    dosyalar.push({
      _id: new FikoYTId().toString(),
      tur: 'klasor',
      ismi: 'Yeni Klasör',
      tarih: new Date().toISOString(),
      ustId: this.aktifKlasorId() || undefined
    });
    this.deger.set({ dosyalar });
  }

  dosyaSec() {
    this.dosyaInput?.nativeElement?.click();
  }

  dosyalarEklendi(event: Event) {
    const input = event.target as HTMLInputElement;
    const files = Array.from(input?.files || []);
    if (!files.length) return;
    const dosyalar = [...(this.deger()?.dosyalar || [])];
    for (const f of files) {
      const oge: IDosyaKutusuOge = {
        _id: new FikoYTId().toString(),
        tur: 'dosya',
        ismi: f.name,
        boyut: f.size,
        tipi: f.type,
        tarih: new Date().toISOString(),
        ustId: this.aktifKlasorId() || undefined
      };
      if (f.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onload = () => { oge.base64 = reader.result as string; this.CD.detectChanges(); };
        reader.readAsDataURL(f);
      }
      dosyalar.push(oge);
    }
    this.deger.set({ dosyalar });
    input.value = '';
  }

  dosyaBirak(event: DragEvent) {
    event.preventDefault();
    this.dragUzerinde.set(false);
    if (this.suruklenenId) {
      this.suruklenenId = null;
      return;
    }
    const files = Array.from(event.dataTransfer?.files || []);
    if (!files.length) return;
    const dosyalar = [...(this.deger()?.dosyalar || [])];
    for (const f of files) {
      const oge: IDosyaKutusuOge = {
        _id: new FikoYTId().toString(),
        tur: 'dosya',
        ismi: f.name,
        boyut: f.size,
        tipi: f.type,
        tarih: new Date().toISOString(),
        ustId: this.aktifKlasorId() || undefined
      };
      if (f.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onload = () => { oge.base64 = reader.result as string; this.CD.detectChanges(); };
        reader.readAsDataURL(f);
      }
      dosyalar.push(oge);
    }
    this.deger.set({ dosyalar });
  }

  klasoreTasi(hedefKlasorId: string, event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    if (!this.suruklenenId || this.suruklenenId === hedefKlasorId) return;
    const dosyalar = [...(this.deger()?.dosyalar || [])];
    const oge = dosyalar.find(d => d._id === this.suruklenenId);
    if (oge) {
      oge.ustId = hedefKlasorId;
      this.deger.set({ dosyalar });
    }
    this.suruklenenId = null;
  }

  ogeSil(id: string) {
    const dosyalar = [...(this.deger()?.dosyalar || [])];
    const silinecekler = new Set<string>();
    const topla = (kid: string) => {
      silinecekler.add(kid);
      dosyalar.filter(d => d.ustId === kid).forEach(d => topla(d._id));
    };
    topla(id);
    this.deger.set({ dosyalar: dosyalar.filter(d => !silinecekler.has(d._id)) });
  }

  private _tikTimer: any = null;
  private _ciftTik = false;

  isimTiklandi(oge: any) {
    if (this._ciftTik) return;
    this._tikTimer = setTimeout(() => {
      if (!this._ciftTik && oge.tur === 'klasor') this.aktifKlasorId.set(oge._id);
      this._tikTimer = null;
    }, 250);
  }

  isimCiftTiklandi(oge: any) {
    this._ciftTik = true;
    clearTimeout(this._tikTimer);
    if (!this.sadeceOkunur()) this.duzenlenenId.set(oge._id);
    setTimeout(() => this._ciftTik = false, 300);
  }

  isimKaydet(id: string, yeniIsim: string) {
    const isim = yeniIsim.trim();
    if (isim) this.ogeGuncelle(id, 'ismi', isim);
    this.duzenlenenId.set(null);
  }

  ogeGuncelle(id: string, alan: string, deger: any) {
    const dosyalar = [...(this.deger()?.dosyalar || [])];
    const oge = dosyalar.find(d => d._id === id);
    if (oge) {
      (oge as any)[alan] = deger;
      this.deger.set({ dosyalar });
    }
  }

  toggleGenislet(id: string) {
    const set = new Set(this.genisletilen());
    set.has(id) ? set.delete(id) : set.add(id);
    this.genisletilen.set(set);
  }

  formatBoyut(byte: number): string {
    if (!byte) return '0 B';
    const birimler = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(byte) / Math.log(1024));
    return (byte / Math.pow(1024, i)).toFixed(i > 0 ? 1 : 0) + ' ' + birimler[i];
  }

  dosyaIkonu(mime?: string): string {
    if (!mime) return '\uD83D\uDCC4';
    if (mime.startsWith('image/')) return '\uD83D\uDDBC\uFE0F';
    if (mime.startsWith('video/')) return '\uD83C\uDFAC';
    if (mime.startsWith('audio/')) return '\uD83C\uDFB5';
    if (mime.includes('pdf')) return '\uD83D\uDCD5';
    if (mime.includes('zip') || mime.includes('rar') || mime.includes('7z')) return '\uD83D\uDCE6';
    if (mime.includes('word') || mime.includes('document')) return '\uD83D\uDCD8';
    if (mime.includes('excel') || mime.includes('sheet')) return '\uD83D\uDCCA';
    if (mime.includes('presentation') || mime.includes('powerpoint')) return '\uD83D\uDCD9';
    return '\uD83D\uDCC4';
  }
}
